import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { PasswordModule } from 'primeng/password';
import { SuccessModalComponent } from '../../shared/components/success-modal/success-modal.component';
import { RolesEnum, loginModel } from '../../interfaces/auth/auth.model';
import { SocketService } from '../../services/socket.service';
import { StrategyService } from '../../services/strategy.service';
import { TranslateModule } from '@ngx-translate/core';
import { sidebarTogglerService } from '../../services/sidebar-toggler.service';
import { DirectionService } from '../../services/direction.service';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PasswordModule,
    InputTextModule,
    ButtonModule,
    FormsModule,
    SuccessModalComponent,
    TranslateModule

  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  passWord = ''
  userName = ''
  showSuccessModal = false;
  dir!: "rtl" | "ltr";
  constructor(private authService: AuthService,
    private router: Router,
    private socketService: SocketService,
    private strategyService: StrategyService,
    private directionService: DirectionService,
    private sidebarTogglerService: sidebarTogglerService,
  ) {
  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe(dir => {
      this.dir = dir;
    })
  }

  onSubmit(form: NgForm) {
    if (form.valid) {
      const value = form.value;
      const loginPayload = {
        username: (value.username ?? value.userName ?? this.userName ?? '').toString().trim(),
        password: (value.password ?? this.passWord ?? '').toString()
      };
      this.authService.login(loginPayload).subscribe((user) => {
        console.log("user", user);
        if (user.role == RolesEnum.admin.toString()) {
          this.router.navigateByUrl('/admin/admin-home');
          this.authService.setCurrentUser(user);
        } else if (user.strategy_exec) {
          this.router.navigateByUrl('/strategy-executor-home');
          this.authService.setCurrentUser(user);
        }
        else if (user.strategy_admin) {
          this.router.navigateByUrl('/strategy-manager-home');
          this.authService.setCurrentUser(user);
        }
        else if (user.senior_admin) {
          this.router.navigateByUrl('/dashboard');
          this.authService.setCurrentUser(user);
        }
        else {

          this.router.navigateByUrl('/strategy');
          this.authService.setCurrentUser(user);
        }
        form.reset();
        this.sidebarTogglerService.setSidaBarState(true);
        this.strategyService.defaultStrategy$.subscribe((strategy) => {
          this.socketService.setRefreshNotification(strategy?.id || 0);
        })
      })


    }


  }















  password: string = '';
  passwordFieldType: string = 'password';
  passwordIconClass: string = 'fa fa-eye-slash';

  togglePasswordVisibility(event: Event): void {
    event.preventDefault();
    if (this.passwordFieldType === 'password') {
      this.passwordFieldType = 'text';
      this.passwordIconClass = 'fa fa-eye';
    } else {
      this.passwordFieldType = 'password';
      this.passwordIconClass = 'fa fa-eye-slash';
    }
  }
}
